import React from "react";
import back from "../../Assets/Mp4/back.mp4"
import tiks from "../../Assets/svg/tiks.svg"
import eye from "../../Assets/svg/eye.svg.svg"
import mawaloglogo from "../../Assets/png/mawaloglogo.png"


const Login=()=>{
    return(
        


        <div style={{display:'flex'}}>
            <div  style={{position: 'relative', width: '650px', height: '650px'}}>
                <video src={back} autoPlay muted loop style={{width:'650px',height:'650px',objectFit:'cover'}}></video>
                <div style={{position:'absolute',top:'50%',left:'50%',transform: 'translate(-50%, -50%)',color:'#FFFFFF',width:'70%'}}>
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                        <div style={{marginBottom:"24px"}}>
                            <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'500',fontSize:'16px',lineHeight:'19.2px',display:'inline-block'}}>MAWALOG</span>
                        </div>
                        <div style={{marginBottom:'40px'}}>
                            <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'700',fontSize:'32px',lineHeight:'38.4px',display:'inline-block'}}>Engineering seamless flow from 
                            factory floor to customer's door</span>
                        </div>                       
                    </div>

                    <div style={{marginBottom:'40px'}}>
                            <div style={{display:'flex',marginBottom:'20px'}}>
                                <div style={{borderRadius:'12px',padding:'10px 10px 10px 20px',backgroundColor:'#00000099',display:'flex',alignItems:'center',width:'256px',height:'54px',marginRight:'20px'}}>
                                    <img src={tiks} alt="" style={{opacity:'100%',width:'18px',height:'18px',marginRight:'14px'}} />
                                    <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'500',fontSize:'15px',lineHeight:'18px',color:'#FFFFFF'}}>Scalability</span>
                                </div>

                                <div style={{borderRadius:'12px',padding:'10px 10px 10px 20px',backgroundColor:'#00000099',display:'flex',alignItems:'center',width:'256px',height:'54px'}}>
                                    <img src={tiks} alt="" style={{opacity:'100%',width:'18px',height:'18px',marginRight:'14px'}} />
                                    <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'500',fontSize:'15px',lineHeight:'18px',color:'#FFFFFF'}}>Real-Time Visibility</span>
                                </div>

                            </div>

                            <div style={{display:'flex'}}>
                                <div style={{borderRadius:'12px',padding:'10px 10px 10px 20px',backgroundColor:'#00000099',display:'flex',alignItems:'center',width:'256px',height:'54px',marginRight:'20px'}}>
                                    <img src={tiks} alt="" style={{opacity:'100%',width:'18px',height:'18px',marginRight:'14px'}} />
                                    <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'500',fontSize:'15px',lineHeight:'18px',color:'#FFFFFF'}}>End to End Solution</span>
                                </div>

                                <div style={{borderRadius:'12px',padding:'10px 10px 10px 20px',backgroundColor:'#00000099',display:'flex',alignItems:'center',width:'256px',height:'54px'}}>
                                    <img src={tiks} alt="" style={{opacity:'100%',width:'18px',height:'18px',marginRight:'14px'}} />
                                    <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'500',fontSize:'15px',lineHeight:'18px',color:'#FFFFFF'}}>Customization</span>
                                </div>

                            </div>
                        </div> 

                        <div style={{borderRadius:'10px',border:'1px dashed #FFFFFF',paddingRight:'16px',paddingLeft:'16px',paddingTop:'10px',paddingBottom:'10px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                            <span style={{fontFamily:'Bricolage Grotesque',fontWeight:'400',fontSize:'16px',lineHeight:'19.2px',color:'#FFFFFF',margin:'0'}}>At Mawalog, we believe in simplifying the complexities of 
                            supply chain management.</span>
                        </div>
                </div>
            </div>

            <div style={{backgroundColor:'#FFFFFF',display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}>
                <div style={{margin:'0',display:'flex',flexDirection:'column'}}>
                    <img src={mawaloglogo} alt=""  style={{height:'24px',width:'120px',marginBottom:'24px'}}/>
                    <span style={{fontFamily:'Aileron',fontWeight:'700',fontSize:'24px',lineHeight:'28.8px',color:'#21272C',marginBottom:'16px'}}>Sign into your account now</span>
                    <span style={{fontFamily:'Aileron',fontWeight:'400',fontSize:'13.5px',lineHeight:'16.2px',color:'#66737E',marginBottom:'32px'}}>Login to your account to get access of your account</span>
                    <input type="text" style={{borderRadius:'8px',padding:'10px 16px 10px 12px',gap:'1px',backgroundColor:'#F5F7F9',marginBottom:'16px',fontFamily:'Aileron',fontWeight:'400',fontSize:'13px',lineHeight:'15.6px',color:'#66737E'}} placeholder="User name or Email" />
                    <div style={{position: 'relative', display: 'inline-block', width: '100%'}}>
                        <input type="password" style={{borderRadius:'8px',padding:'10px 16px 10px 12px',gap:'1px',width: '100%',backgroundColor:'#F5F7F9',marginBottom:'16px',fontFamily:'Aileron',fontWeight:'400',fontSize:'13px',lineHeight:'15.6px',color:'#66737E',marginBottom:'20px'}}placeholder="Enter Password" />
                        <img src={eye} style={{width:'14px',height:'11.2px',position: 'absolute',transform: 'translateY(-50%)',right:'10px',top:'35%',cursor: 'pointer'}} />
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:'24px',alignItems:"center"}}>
                        <div style={{display:'flex'}}>
                            <input type="checkbox"/>
                            <span style={{fontFamily:'Aileron',fontWeight:'600',fontSize:'13px',lineHeight:'15.6px',color:'#21272C',marginLeft:'10px'}}>Remember me</span>
                        </div>

                        <div style={{margin:'0'}}>
                            <span style={{fontFamily:'Aileron',fontWeight:'600',fontSize:'13px',lineHeight:'15.6px',color:'#004BAB',marginLeft:'10px'}}>Forget Password ?</span>
                        </div>
                    </div>
                    <div style={{padding:'10px',borderRadius:'37px',display:'flex',justifyContent:'center',alignItems:'center',gap:'235px',backgroundColor:'#004BAB'}}>
                        <span style={{fontFamily:'Aileron',margin:'0',fontWeight:'700',fontSize:'15px',lineHeight:'18px',color:'#FFFFFF'}}>Log in</span>
                    </div>


                </div>
                

            </div>

        </div>
    );
};

export default Login;